var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobi(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 0.9375C4.33594 0.9375 3.96094 1.07813 3.70313 1.35938C3.44531 1.64063 3.28125 1.99219 3.28125 2.34375V27.6562C3.28125 28.0078 3.42188 28.3828 3.70313 28.6406C3.98438 28.9219 4.33594 29.0625 4.6875 29.0625H25.3125C25.6641 29.0625 26.0391 28.9219 26.2969 28.6406C26.5781 28.3594 26.7188 28.0078 26.7188 27.6562V8.90625L18.75 0.9375H4.6875Z",
    fill: "#DE4C38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3072 11.7324C20.9384 11.0411 22.0898 11.4877 22.0898 12.4238V23.3223H20.0391V15.0676L15.9623 19.5327C15.5557 19.9781 14.8545 19.9781 14.4478 19.5327L10.3711 15.0676V23.3223H8.32031V12.4238C8.32031 11.4877 9.47174 11.0411 10.1029 11.7324L15.2051 17.3206L20.3072 11.7324Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7188 8.90625H20.1562C19.8047 8.90625 19.4297 8.76562 19.1719 8.48438C18.8906 8.22656 18.75 7.85156 18.75 7.5V0.9375L26.7188 8.90625Z",
    fill: "#FFEDE5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobi);
export default __webpack_public_path__ + "static/media/mobi.7fad415a25188a9dfa300446363e558f.svg";
export { ForwardRef as ReactComponent };